import React from 'react';
import { GiGraduateCap } from 'react-icons/gi';
import QualificationContent from './QualificationContent';

const Qualification = ({qualifications}) => {
  
    return (
        <div className="qualification">
            {/* qualification title */}
          <div className="titles flex items-center ">
            <div className="icon mr-3">
              <GiGraduateCap color="#C147E9" size={60} />
            </div>

            <h2 className="text-3xl font-bold"> Educational Qualification</h2>
          </div>


          {/* qualification conotent */}

         <div className='qqt mt-6'>
          {
            qualifications.map((qualification) =>
            <QualificationContent
            qualification={qualification}
            />
          )}
        
        
         </div>



        </div>
    );
};

export default Qualification;